<template>
  <master-page style="display: flex ; align-items: center">
    <div style="display: flex ; align-items: center ; justify-content: center" class="pa-6">
      
      <v-card width="1000px">
        
        <v-toolbar color="primary" style="color: white">
          <v-toolbar-title>Envio de Boleto</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn dark text @click="Limpar()" :loading="loading">Limpar</v-btn>
            <v-btn dark text @click="Enviar()" :loading="loading" :disabled="!valid">Enviar</v-btn>
            <info/>
          </v-toolbar-items>
        </v-toolbar>
        
        <v-card-text>
          <v-form id="form" ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="6" md="5">
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                  <template v-slot:activator="{on}">
                    <!-- PERIODO -->
                    <v-text-field v-if="periodo" v-model="dataInicial" v-mask="maskAno" placeholder="mm/aaaa" label="Mês/Ano Inicial" :rules="fieldRules" dense outlined clearable>
                      <template v-slot:prepend>
                        <v-icon v-on="on">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                    <!-- UNICO -->
                    <v-text-field v-else v-model="dataInicial" v-mask="maskAno" placeholder="dd/mm/aaaa" label="Dia/Mês/Ano" :rules="fieldRules" dense outlined clearable>
                      <template v-slot:prepend>
                        <v-icon v-on="on">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-if="periodo" v-model="dataInicialOriginal" locale="pt-br" type="month" scrollable no-title/>
                  <v-date-picker v-else v-model="dataInicialOriginal" locale="pt-br" scrollable no-title/>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="5" v-show="periodo">
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                  <template v-slot:activator="{on}">
                    <v-text-field :disabled="!periodo" v-model="dataFinal" v-mask="'##/####'" placeholder="mm/aaaa" label="Mes/Ano Final" :rules="periodo ? fieldRules : []" dense outlined clearable>
                      <template v-slot:prepend>
                        <v-icon v-on="on">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataFinalOriginal" locale="pt-br" type="month" scrollable no-title/>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-switch v-model="periodo" style="margin-top: -5px" label='Enviar por período' hide-details/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea label="Log" v-model="log" outlined dense readonly/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      
      </v-card>

    </div>    
  </master-page>
</template>

<script>
import RecebivelService from '../../../core/services/financeiro/RecebivelService'

export default {
  data: () => ({
    dataInicialOriginal: null,
    dataFinalOriginal: null,
    dataInicial: null,
    dataFinal: null,
    periodo: true,
    log: '',
    service: new RecebivelService(),
    loading: false,
    fieldRules: [
      v => !!v || 'Campo obrigatório'
    ],
    valid: true,
    maskAno: '##/####'
  }),
  created() {
    
  },
  mounted() {
    if ('form' in this.$refs)
      this.$refs.form.resetValidation();
  },
  watch:{
    dataInicial(){
      if(!this.dataInicial)
        return;

      if(this.dataInicial.length == 7){
        this.dataInicialOriginal == this.dataInicial
      }

    },
    dataFinal(){
      if(!this.dataFinal)
        return;

      if(this.dataFinal.length == 7){
        this.dataFinalOriginal == this.dataFinal;
      }

    },
    dataInicialOriginal(){
      if(!this.dataInicialOriginal)
        return;
      this.dataInicial = this.dataInicialOriginal.replace('-','/');
      let mes = this.dataInicial.split('/')[1];
      let ano = this.dataInicial.split('/')[0];
      this.dataInicial = mes + '/' + ano;
    },
    dataFinalOriginal(){
      if(!this.dataFinalOriginal)
        return;
      this.dataFinal = this.dataFinalOriginal.replace('-','/');
      let mes = this.dataFinal.split('/')[1];
      let ano = this.dataFinal.split('/')[0];
      this.dataFinal = mes + '/' + ano;
    },
    periodo(){
      let vm = this;
      vm.maskAno = '';

      this.Limpar().finally(() => {
        if(vm.periodo){
          vm.maskAno = '##/####';
        }
        else{
          vm.maskAno = '##/##/####';
        }
      });
      
    },
  },
  methods: {
    Enviar(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.service.EnviarBoleto(this.dataInicial, this.dataFinal, this.periodo).then(
          res =>{
            this.log = res.data.log;
            if(res.data.ids){
              let routeLink = this.$router.resolve({ name: "imprimirBoleto",
                query:{
                  ids: res.data.ids
                }
              });
              window.open(routeLink.href,'_blank');
            }
            else{
              this.$swal('Aviso', "Não existem boletos a serem enviados.", 'warning');
            }
          },
          err =>{
            this.$swal('Aviso', err.response.data, 'error')
          }
        ).finally(() => {
          this.loading = false;
        })
      }
    },
    Limpar() {

      let vm = this;
      return new Promise(function(resolve) {

        if ('form' in vm.$refs)
          vm.$refs.form.resetValidation();

        vm.dataInicial = null;
        vm.dataInicialOriginal = null;
        vm.dataFinalOriginal = null;
        vm.dataFinal = null;
        vm.log = "";

        resolve(true);
      });
      
    }
  },
}
</script>
